<ng-container *ngIf="!item.hidden">
  <!-- item with router url -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && !item.externalUrl && !item.actionMethod"
    [routerLink]="[item.url]"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- item with external url -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && item.externalUrl && !item.actionMethod"
    [href]="item.url"
    [target]="item.openInNewTab ? '_blank' : '_self'"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- item de tipo acción: no navega, hace la petición a su url -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    *ngIf="item.url && item.actionMethod"
    href="#"
    role="button"
    (click)="runAction($event)"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <ng-template #itemContent>
    <!-- El icono puede ser un nombre de lucide, una clase de fuente o una imagen subida -->
    <app-lucide-icon class="menu-icon-lucide" [name]="lucideIconName(item.icon)" [size]="18"
                     *ngIf="isLucideIcon(item.icon)"></app-lucide-icon>
    <img class="menu-icon-img" [src]="item.icon" alt="" *ngIf="isImageIcon(item.icon)" />
    <span [ngClass]="item.icon" class="fa-lg fa-fw" *ngIf="(item.icon && !isLucideIcon(item.icon) && !isImageIcon(item.icon) && item.icon.startsWith('fa'))"></span>
    <span [data-feather]="item.icon" *ngIf="(item.icon && !isLucideIcon(item.icon) && !isImageIcon(item.icon) && !item.icon.startsWith('fa'))"></span>
    <span class="menu-title text-wrap"> {{ (item.translate | translate) || item.title }}</span>
    <span
      class="badge ml-auto mr-1"
      *ngIf="item.badge"
      [translate]="item.badge.translate"
      [ngClass]="item.badge.classes"
    >
      {{ item.badge.title }}
    </span>
  </ng-template>
</ng-container>
